export default {
  data() {
    return {
      userAuth: false,
    }
  },
  methods: {
    checkUser() {
      this.userAuth = false

      this.$axios
        .get(`check-user`)
        .then(res => {
          if (res && res.status === 200) {
            this.userAuth = true
            if (!this.isLocal) {
              this.$store.dispatch('keepAlive', true)
            }
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    checkUserSavitarna() {
      this.userAuth = false

      if (this.$route.params.sign || !this.$route.query.enc) {
        this.checkUser()
        return
      }

      this.$axios
        .post(`ipasas`, { enc: this.$route.query.enc })
        .then(res => {
          if (res && res.status === 200) {
            const dispatchData = {
              naudotojas: res.data.naudotojas,
              roles: res.data.roles,
              xid: this.$route.query.xid,
            }
            this.$store.dispatch('savitarnaLogin', dispatchData).then(() => {
              this.$store.dispatch('loadTooltips')
              this.userAuth = true
              history.pushState({}, null, this.$route.path)
              if (res.data.pirmas_prisijungimas) {
                this.$store.dispatch('savitarnaSutartis', false)
              }
            })
          }
        })
        .catch(err => {
          window._VMA.$emit('SAV_LOGIN_ERROR')
        })
    },
  },
}
